import type { AnyAction, Dispatch } from '@reduxjs/toolkit';

import { adminAccessApi } from 'api/AdminAccessApi';
import { adminAccessMessagesApi } from 'api/AdminAccessMessagesApi';
import { authApi } from 'api/AuthApi';
import { commonApi } from 'api/CommonApi';
import { contactsApi } from 'api/ContactsApi';
import { designApi } from 'api/DesignApi';
import { flowAiApi } from 'api/FlowAiApi';
import { giftsApi } from 'api/GiftsApi';
import { hipaaApi } from 'api/HipaaApi';
import { inboxApi } from 'api/InboxApi';
import { lifeReviewApi } from 'api/LifeReviewApi';
import { messageAiApi } from 'api/MessageAiApi';
import { messagesApi } from 'api/MessagesApi';
import { organizationInvitesApi } from 'api/OrganizationInvitesApi';
import { paymentApi } from 'api/PaymentApi';
import { sysAdminApi } from 'api/SysAdminApi';
import { usersApi } from 'api/UsersApi';

export const LIFE_REVIEW_DRAFT_STORAGE_KEY_PREFIX = 'lifeReviewDraftByPromptId';

export const SENSITIVE_STORAGE_PREFIXES = [LIFE_REVIEW_DRAFT_STORAGE_KEY_PREFIX];

const apiSlices = [
  authApi,
  designApi,
  commonApi,
  usersApi,
  contactsApi,
  giftsApi,
  organizationInvitesApi,
  flowAiApi,
  messageAiApi,
  messagesApi,
  inboxApi,
  lifeReviewApi,
  hipaaApi,
  adminAccessApi,
  adminAccessMessagesApi,
  paymentApi,
  sysAdminApi
];

const clearStorageByPrefixes = (storage: Storage | undefined, prefixes: string[]) => {
  if (!storage) {
    return;
  }

  const keysToRemove: string[] = [];
  for (let i = 0; i < storage.length; i += 1) {
    const key = storage.key(i);
    if (key && prefixes.some((prefix) => key.startsWith(prefix))) {
      keysToRemove.push(key);
    }
  }

  keysToRemove.forEach((key) => storage.removeItem(key));
};

export const clearSecuritySensitiveStorage = () => {
  if (typeof window === 'undefined') {
    return;
  }

  clearStorageByPrefixes(window.localStorage, SENSITIVE_STORAGE_PREFIXES);
  clearStorageByPrefixes(window.sessionStorage, SENSITIVE_STORAGE_PREFIXES);
};

export const runSecurityTeardown = (dispatch: Dispatch<AnyAction>) => {
  clearSecuritySensitiveStorage();
  apiSlices.forEach((api) => dispatch(api.util.resetApiState()));
};
